import { LoaderFunctionArgs, useLoaderData } from 'react-router-dom';
import invariant from 'tiny-invariant';
import { JobView } from '~/components/job/JobView';

export const loader = ({ params }: LoaderFunctionArgs) => {
  const { jobId } = params;

  invariant(jobId, 'jobId is required');

  return { jobId };
};

export default function SiteAssetJobViewRoute() {
  const { jobId } = useLoaderData() as ReturnType<typeof loader>;

  return <JobView jobId={jobId} />;
}
